import { X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import { preferencesService } from '../../services/api';
import { AVATARS } from './UserAvatar';

const AvatarPickerModal = ({ onClose }) => {
    const { user, setUser } = useAuth();
    const { language } = useLanguage();

    const selectAvatar = async (avatarId) => {
        await preferencesService.save({ avatarId });
        setUser(prev => ({ ...prev, dashboardPrefs: { ...prev.dashboardPrefs, avatarId } }));
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[400] p-4" onClick={onClose}>
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 max-w-md w-full shadow-2xl" onClick={e => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-5">
                    <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                        {language === 'fr' ? 'Choisir un avatar' : 'Choose an avatar'}
                    </h3>
                    <button onClick={onClose} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition">
                        <X className="w-5 h-5 text-gray-400" />
                    </button>
                </div>
                <div className="grid grid-cols-5 gap-3">
                    <button
                        onClick={() => selectAvatar(null)}
                        className={`aspect-square rounded-2xl border-2 transition-all hover:scale-105 flex items-center justify-center ${
                            !user?.dashboardPrefs?.avatarId
                                ? 'border-blue-500 ring-2 ring-blue-500/30'
                                : 'border-gray-200 dark:border-white/10 hover:border-gray-300 dark:hover:border-white/20'
                        }`}
                    >
                        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                            <span className="text-sm font-bold text-white">{user?.name?.[0]?.toUpperCase() || '?'}</span>
                        </div>
                    </button>
                    {AVATARS.map(av => (
                        <button
                            key={av.id}
                            onClick={() => selectAvatar(av.id)}
                            className={`aspect-square rounded-2xl border-2 transition-all hover:scale-105 overflow-hidden ${
                                user?.dashboardPrefs?.avatarId === av.id
                                    ? 'border-blue-500 ring-2 ring-blue-500/30'
                                    : 'border-gray-200 dark:border-white/10 hover:border-gray-300 dark:hover:border-white/20'
                            }`}
                        >
                            <img src={av.src} alt="" className="w-full h-full object-cover" />
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AvatarPickerModal;
